import { Routes, mapToCanActivate, mapToResolve } from "@angular/router";

import { EntityBuilderComponent } from "./components/entitybuilder/entitybuilder.component";
import { EntityListComponent } from "./components/entitylist/entitylist.component";
import { EntityResolver } from "./resolvers/entity.resolver";
import { BaseGuardService } from "../auth/guards/base-guard.service";
import { SystemPermissionGuardService } from "../auth/guards/system-permission-guard.service";
import { LunaClaimValues } from "../models/user-identity.model";

const routeGuards = [BaseGuardService, SystemPermissionGuardService];

export const EB_ROUTES: Routes = [
    {
        path: "entity/:id",
        component: EntityBuilderComponent,
        resolve: { entity: mapToResolve(EntityResolver) },
        canActivate: mapToCanActivate(routeGuards),
        data: { permission: LunaClaimValues.ManageEntities }
    },
    {
        path: "list",
        component: EntityListComponent,
		canActivate: mapToCanActivate(routeGuards),
        data: { permission: LunaClaimValues.ManageEntities }
    },
    { path: "",
    redirectTo: "list",
    pathMatch: "full",
    data: { permission: LunaClaimValues.ManageEntities } }
];